"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
const collaborators = [];
export default function TheTeamCollaborators() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}